// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".snackbar-content-wrapper{-ms-flex-wrap:nowrap !important;flex-wrap:nowrap !important;word-break:break-word}\n", ""]);
// Exports
module.exports = exports;
